import React from 'react'
import { Text, SummaryExercise, Heading } from 'components/library'
import pdf from './assets/5c8a1c4bfe36da2d5e24d52d-1555062852462-H5_Communicatie_in_de_praktijk_SLEEP.pdf'

const Intro = props => (
	<div>
		<Text><strong>In dit hoofdstuk leer je:</strong></Text>
		<ul style={{marginTop: '0'}}>
			<li>welke afspraken er gelden tijdens de communicatie;</li>
			<li>welke stappen er zijn in het communicatieprotocol voor het aanvragen van een sleepbeweging;</li>
			<li>welke stappen er zijn in het communicatieprotocol voor het aanvragen van een baankruising;</li>
			<li>welke standaard berichten je moet kennen en gebruiken tijdens sleepbewegingen.</li>
		</ul>
	</div>
)

const Summary = props => (
	<div>
		<div>
			<ul style={{marginTop: '0'}}>
				<li>welke afspraken er gelden tijdens de communicatie;</li>
				<li>welke stappen er zijn in het communicatieprotocol voor het aanvragen van een sleepbeweging;</li>
				<li>welke stappen er zijn in het communicatieprotocol voor het aanvragen van een baankruising;</li>
				<li>welke standaardberichten je moet kennen en gebruiken tijdens sleepbewegingen.</li>
			</ul>
		</div>

		<div>
			<SummaryExercise link={pdf}>
				<Heading h3>Communicatie in de praktijk</Heading>
		    <ul style={{marginTop: '0'}}>
		      <li>Ga een tijdje luisteren naar een van de frequenties van Apron Control en laat de instructeur uitleggen wat je hoort. Probeer na een tijdje zelf te begrijpen wat er wordt gezegd en wat er van je gevraagd wordt als jij de sleepchauffeur zou zijn.</li>
		      <li style={{margin: '3rem 0'}}>Vraag aan je instructeur of jullie eens kunnen oefenen met de verschillende radio-protocollen zodat je ze uit je hoofd kunt leren. </li>
		      <li>Vraag aan je instructeur of hij/zij aan je kan laten zien hoe je overschakelt van Apron Control naar LVNL.</li>
		    </ul>
			</SummaryExercise>
		</div>
  </div>
)

export { Intro, Summary }



// WEBPACK FOOTER //
// ./src/content/chapters/05/index.js